import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

import Login from './views/Login.vue'
import Regions from './views/Regions.vue'
import Branches from './views/Branches.vue'
import Outlets from './views/Outlets.vue'
import Employees from './views/Employees.vue'
import Profile from './views/Profile.vue'
import Admins from './views/Admins.vue'
import Logs from './views/Logs.vue'
import Approval from './views/Approval.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'regions',
      component: Regions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/branches',
      name: 'branches',
      component: Branches,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/outlets',
      name: 'outlets',
      component: Outlets,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/employees',
      name: 'employees',
      component: Employees,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admins,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/approval',
      name: 'approval',
      component: Approval,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: '/404',
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  var requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // console.log(requiresAuth)
  if(requiresAuth && !store.state.accessToken){
    next('/login')
  }
  if(!requiresAuth && store.state.accessToken){
    next('/')
  }
  next();
});

export default router